import { bootstrap } from '@central-products/bootstrapper';
import MessageBusTransport from '@central-products/message-transport-bus';
import MessageBusTransportPostal from '@central-products/message-transport-bus-postal';
import { init } from './init';

// eslint-disable-next-line camelcase, no-undef
__webpack_public_path__ = window.kraken.config.publicPath;

const messageBusTransport =
  process.env.VERTICAL === 'unity' ? MessageBusTransportPostal.getInstance() : MessageBusTransport.getInstance();

init({
  krakenConfig: window.kraken,
  bootstrap: (bootstrapperFeatures, bootstrapperConfig) => {
    const { init: initBootstrapper, features: initializedBootstrapperFeatures } = bootstrap(
      messageBusTransport,
      bootstrapperFeatures,
      bootstrapperConfig
    );
    return { initBootstrapper, initializedBootstrapperFeatures };
  },
}).catch(console.error);
